import React, { useContext } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { SanContext } from "../../../../san/schema";
import { serviceProfileAllows } from "../../../../serviceProfile/validator";
import { TreeBlockConfigurations, treeBlockConfigurations } from "../../schema";
import { TreeBlockType } from "../../TreeBlockType";
import { TrayItemWidget } from "./TrayItemWidget";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingTop: "20px",
      width: "200px",
      maxWidth: "200px",
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      flexDirection: "column",
      maxHeight: "82vh",
      overflowY: "auto"
    }
  })
);

export const TrayWidget = () => {
  const classes = useStyles();
  const blocks: TreeBlockConfigurations = { ...treeBlockConfigurations };
  const SAN = useContext(SanContext);

  const treeBlockTypes = Object.keys(blocks) as TreeBlockType[];

  return (
    <div className={classes.container}>
      {treeBlockTypes.map((block: TreeBlockType, index: number) => {
        const name = blocks[block].name;
        return (
          block !== TreeBlockType.ROOT &&
          serviceProfileAllows(
            { data: SAN.oneDataSource.one },
            blocks[block].if
          ) && (
            <TrayItemWidget
              key={index}
              model={{ type: block }}
              name={name()}
              color={blocks[block].color}
            />
          )
        );
      })}
    </div>
  );
};
